export default {

    isLoggedIn: false,
    abilities: {},
    access: {},
    breadcrumbs: 2,
    URL_ASSETS: 'https://www.assets.behaustcode.com/',
    URL_API: 'https://lms-api.rsudbandungkiwari.or.id/api/v1/',
}